import { LBSUtils } from '../_util/lbs-utils';
import { HasImplementationProperties } from './has-implementation-propeties';
import { ImplementationPropertiesUtil } from './implementation-properties-utils';
import { IMSObject, IMSId } from './ims-object';

/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190402 by Jan Brunner
 *     all rights reserved.
 */

export class Material extends IMSObject implements HasImplementationProperties {
  static fromDto(dto: MaterialDTO, databag?: any) {
    const obj = new this(
      {
        imsId: dto.id,
        secondaryId: dto.secondaryid,
        objRef: 'ims/Material',
      },
      dto.label,
      dto.unit,
      dto.groupid,
      dto.name,
      dto.searchkey,
      dto.extid,
      dto.costcenter,
      dto.wtrelevant ? dto.wtrelevant : true,
    );

    if (databag) {
      obj.databag = databag;
    } else {
      obj.databag = dto;
    }

    console.log("JBImplProp test output on material:", obj.implementationProperties.implProps)
    return obj;
  }

  public get implementationProperties(): ImplementationPropertiesUtil {
    return new ImplementationPropertiesUtil(this);
  }

  constructor(
    public readonly id: IMSId,
    label: string,
    public unit?: string,
    public groupid?: string,
    public name?: string,
    public searchkey?: string,
    public extid?: string,
    public costcenter?: number,
    public wtrelevant?: boolean,
  ) {
    super(id.imsId, id.secondaryId, label, 'ims/Material');
  }

  public get isweighingmaterial(): boolean {
    return this.databag.isweighingmaterial;
  }
  public set isweighingmaterial(v: boolean) {
    this.databag.isweighingmaterial = v;
  }

  public get puamount(): number {
    return this.databag.puamount;
  }
  public set puamount(v: number) {
    this.databag.puamount = v;
  }

  public get weightTolerance(): number {
    return this.databag.weighttolerance;
  }
  public set weightTolerance(v: number) {
    this.databag.weighttolerance = v;
  }

  public get isorganic(): boolean {
    return this.databag.isorganic;
  }
  public set isorganic(v: boolean) {
    this.databag.isorganic = v;
  }

  public get puinfo(): string {
    return this.databag.puinfo;
  }
  public set puinfo(v: string) {
    this.databag.puinfo = v;
  }

  public get taxcode(): number {
    return this.databag.taxcode;
  }
  public set taxcode(v: number) {
    this.databag.taxcode = v;
  }

  public get countryoforigin(): string {
    return this.databag.countryoforigin;
  }
  public set countryoforigin(v: string) {
    this.databag.countryoforigin = v;
  }

  public get categoryname(): string {
    return this.databag.categoryname;
  }
  public set categoryname(v: string) {
    this.databag.categoryname = v;
  }

  public get additionalinfotext(): string {
    return this.databag.additionalinfotext;
  }
  public set additionalinfotext(v: string) {
    this.databag.additionalinfotext = v;
  }

  public get additionalinfotextHtml(): string {
    return this.databag.additionalinfotexthtml;
  }
  public set additionalinfotextHtml(v: string) {
    this.databag.additionalinfotexthtml = v;
  }

  public get subgroupname(): string {
    return this.databag.subgroupname;
  }
  public set subgroupname(v: string) {
    this.databag.subgroupname = v;
  }

  public get extid2(): string {
    return this.databag.extid2;
  }
  public set extid2(v: string) {
    this.databag.extid2 = v;
  }

  public get isPlaceholderMaterial(): boolean {
    return LBSUtils.convertStringBool(
      this.databag.isplaceholdermaterial,
      false,
    );
  }
  public set isPlaceholderMaterial(v: boolean) {
    this.databag.isplaceholdermaterial = v;
  }

  public get articleImages(): number[] {
    const articleImages: string = this.getValueFromDatabag('articleimages');

    if (articleImages == undefined) {
      return [];
    }

    return articleImages.split(',').map((it) => +it);
  }

  public get sortKey(): string {
    return this.databag.sortkey;
  }

  public set sortKey(v: string) {
    this.databag.sortkey = v;
  }

  public get itemIdentifiers(): ItemIdentifierDTO[] {
    return this.databag.itemidentifier;
  }

  public get isExternal(): boolean {
    return LBSUtils.convertStringBool(this.databag.isexternal, false);
  }
  public get isDeposit(): boolean {
    return LBSUtils.convertStringBool(
      this.databag.isdeposit,
      false,
    );
  }
}

export interface MaterialDTO {
  id: number;
  secondaryid: number;
  label: string;
  unit: string;
  groupid: string;
  name: string;
  searchkey: string;
  extid: string;
  costcenter: number;
  wtrelevant: boolean;
  itemidentifier?: ItemIdentifierDTO[];
}

export interface ItemIdentifierDTO {
  syscode: string;
  gtin: string;
  id: number;
  label: string;
}
